module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="job-card__title-container">\n    <div class="job-card__title">\n        <a href="' +
__e( link ) +
'">' +
__e( title ) +
'</a>\n    </div>\n    <div class="job-card__keymeta">\n        <span class="job-card__company">' +
__e( company_name ) +
'</span>\n        <span class="job-card__location">' +
__e( location_name ) +
'</span>\n    </div>\n</div>\n\n<div class="job-card__meta">\n    ';
 if (wage > 0) { ;
__p += '\n        <div class="job-card__meta-field">\n            ' +
((__t = ( $.svgIcon('wallet') )) == null ? '' : __t) +
'\n            <span class="job-card__meta-value">$' +
__e( wage ) +
'/hour</span>\n        </div>\n    ';
 } ;
__p += '\n    ';
 if (schedule_start) { ;
__p += '\n        <div class="job-card__meta-field">\n            ' +
((__t = ( $.svgIcon('watch') )) == null ? '' : __t) +
'\n            <span class="job-card__meta-value">' +
__e( schedule_start ) +
'</span>\n        </div>\n    ';
 } ;
__p += '\n</div>\n\n<div class="job-card__details-container">\n    <div class="job-card__details">\n        <p>' +
((__t = ( description )) == null ? '' : __t) +
'</p>\n    </div>\n</div>\n\n';
 if (autoMatch) { ;
__p += '\n    <div class="job-card__auto-match-bar">\n        <img src="' +
__e( $.staticURL('autoMatch.svg') ) +
'" class="job-card__auto-match-icon" />\n        You\'re pre-qualified to interview! <em>Why?</em>\n    </div>\n';
 } ;
__p += '\n\n<div class="job-card__map">\n    <div class="position-map mobile">\n        <img src="' +
__e( small_map_url ) +
'" />\n        <div class="position-map-commute">\n            ' +
((__t = ( $.svgIcon('pin') )) == null ? '' : __t) +
'\n\n            ';
 if (commute_times.driving || commute_times.transit) { ;
__p += '\n                <div class="position-map-commute-dialog">\n                    <div class="position-commute-times">\n                        ';
 if (commute_times.driving) { ;
__p += '\n                            <div class="position-commute-time position-driving-time">\n                                ' +
((__t = ( $.svgIcon('driving') )) == null ? '' : __t) +
'\n                                <span>';
 if (commute_times.driving >= 120) { ;
__p += '120+';
 } else { ;
__p +=
__e( commute_times.driving );
 } ;
__p += ' min</span>\n                            </div>\n                        ';
 } ;
__p += '\n                        ';
 if (commute_times.transit) { ;
__p += '\n                            <div class="position-commute-time position-transit-time">\n                                ' +
((__t = ( $.svgIcon('transit') )) == null ? '' : __t) +
'\n                                <span>';
 if (commute_times.transit >= 120) { ;
__p += '120+';
 } else { ;
__p +=
__e( commute_times.transit );
 } ;
__p += ' min</span>\n                            </div>\n                        ';
 } ;
__p += '\n                    </div>\n                </div>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n</div>\n<div class="job-card__added job-card__text" style="display: none">\n    <div class="job-card__text-content">\n        ' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'\n        <p>' +
__e( approved_text ) +
'</p>\n    </div>\n</div>\n';

}
return __p
}